module.exports = __webpack_public_path__ + "img/Pic_XXFW_XCX.8e67ddd5.png";